import ComponentWithSocket from '../../../lib/component';
import CKEditor from 'ckeditor4-vue';
import { Component } from 'vue-property-decorator';

@Component({
    components: { ckeditor: CKEditor.component },
})
export default class BlogManage extends ComponentWithSocket {
    private readonly token = 'c8f02a40c3fa8e6383228cc95242aac3';

    public id: string = '';

    public article: {
        title: string;
        slug: string;
        excerpt: string;
        content: string;
        featuredImageAlt: string;
        metaTitle: string;
        metaDescription: string;
        status: number;
    } = {
        title: '',
        slug: '',
        excerpt: '',
        content: '',
        featuredImageAlt: '',
        metaTitle: '',
        metaDescription: '',
        status: 0,
    };

    public featuredImageSrc: string = '';
    public featuredImageFile: any = undefined;

    public updateBtnLoading: boolean = false;
    public updateArticleSuccess: string = '';
    public updateArticleError: string = '';

    public statusOptions = [
        { value: 0, text: 'Draft' },
        { value: 1, text: 'Publicat' },
    ];

    public ckeditorConfig: any = {
        entities_latin: false,
        basicEntities: false,
        language: 'ro',
    };

    constructor() {
        super();
    }

    mounted() {
        this.id = this.$root.$route.params.id;
        this.getArticle();
    }

    async getArticle() {
        await fetch(`${process.env.API2_URL}/article/${this.id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (!response.ok) {
                throw new Error(`Eroare: ${response.status}`);
            }

            return response.json();
        }).then(data => {
            if (data && data.success) {
                const a = data.data;
                this.article.title = a.title || '';
                this.article.slug = a.slug || '';
                this.article.excerpt = a.excerpt || '';
                this.article.content = a.content || '';
                this.article.featuredImageAlt = a.featuredImageAlt || '';
                this.article.metaTitle = a.metaTitle || '';
                this.article.metaDescription = a.metaDescription || '';
                this.article.status = typeof a.status === 'number' ? a.status : 0;
                this.featuredImageSrc = a.featuredImage || '';
            }
        }).catch(error => {
            console.error('Error:', error);
        });
    }

    async updateArticleAction() {
        if (!this.article.title || !this.article.slug) {
            alert('Te rugam sa completezi titlul si slug-ul');
            return;
        }

        // tslint:disable:no-null-keyword — null is sent intentionally so the API clears emptied fields on update
        const payload: any = {
            title: this.article.title,
            slug: this.article.slug,
            excerpt: this.article.excerpt || null,
            content: this.article.content || null,
            featuredImageAlt: this.article.featuredImageAlt || null,
            metaTitle: this.article.metaTitle || null,
            metaDescription: this.article.metaDescription || null,
            status: this.article.status,
        };
        // tslint:enable:no-null-keyword

        if (this.featuredImageFile) {
            payload.featuredImage = await this.convertToBase64(this.featuredImageFile);
        }

        this.updateBtnLoading = true;

        await fetch(`${process.env.API2_URL}/article/${this.id}?token=${this.token}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).then(response => {
            return response.json().then(data => ({ ok: response.ok, status: response.status, data }));
        }).then(({ ok, data }) => {
            this.updateBtnLoading = false;

            if (ok && data && data.success) {
                this.updateArticleSuccess = data.message;
                this.updateArticleError = '';
                if (data.data && data.data.featuredImage) {
                    this.featuredImageSrc = data.data.featuredImage;
                }
                this.featuredImageFile = undefined;
            } else {
                this.updateArticleError = (data && data.message) || 'Eroare la salvare';
                this.updateArticleSuccess = '';
            }
        }).catch(error => {
            console.error('Error:', error);
            this.updateArticleError = String(error);
            this.updateArticleSuccess = '';
            this.updateBtnLoading = false;
        });
    }

    convertToBase64(image: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (e: any) => {
                if (!e.target) {
                    reject(new Error('No target'));
                    return;
                }

                resolve(e.target.result);
            };

            reader.onerror = error => {
                reject(error);
            };

            reader.readAsDataURL(image);
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/blog/manage/index.ts